import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BaseComponent } from "./base/base.component";
import { HeaderMainComponent } from "./header/header.component";
import { FooterMainComponent } from "./footer/footer.component";

import { TranslateModule } from "@ngx-translate/core";
import { MainComponent } from "../Components/main/main.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatButtonModule } from "@angular/material/button";
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import { Header2Component } from './header2/header2.component';
import { MatSelectModule } from "@angular/material/select";
import { AlertTempComponent } from "./alert-temp/alert-temp.component";

@NgModule({
  declarations: [
    BaseComponent,
    HeaderMainComponent,
    FooterMainComponent,
    MainComponent,
    Header2Component,
    AlertTempComponent
  ],
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    RouterModule,
    FormsModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatGridListModule,
    MatDividerModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule
  ],
  exports: [FormsModule, ReactiveFormsModule],
})
export class LayoutModule {}
